import { Injectable } from '@angular/core';

import { WorkspaceInterface } from '@reach/interfaces/workspaces/workspace.interface';
import { GetWorkspacesResponse } from '@reach/interfaces/workspaces/workspaces.responses';

import { BaseApiService } from '~ng-common-lib/core/api/base.api.service';

import {
	workspaceTrashedNodesTransformer,
	workspaceUnassignedNodesTransformer,
} from './utils/extra-workspaces.utils';
import { ClientWorkspace, ClientWorkspaceType } from './workspace.type';

@Injectable({ providedIn: 'root' })
export class WorkspacesApiService extends BaseApiService {
	protected readonly commonPath = ['workspaces'];

	public async get(): Promise<ClientWorkspace[]> {
		const params = { t: this.paramTime };
		const response = await this.http.get<GetWorkspacesResponse>(this.url(), params);
		return parseGetFromServer(response);
	}

	public async getAll(): Promise<GetWorkspacesResponse> {
		const params = { t: this.paramTime };
		return await this.http.get<GetWorkspacesResponse>(this.url(), params);
	}
}

const parseWorkspaceFromServer = (
	workspace: WorkspaceInterface & { count?: number }
): ClientWorkspace => {
	return {
		id: workspace.id,
		name: workspace.name,
		description: workspace.description ?? '',
		type: ClientWorkspaceType.NORMAL,
		count: workspace.count ?? 0,
		emoji: workspace.emoji,
		thumbnailUrl: workspace.thumbnailUrl,
		integrationId: workspace.integrationId,
		createdAt: workspace.createdAt,
		updatedAt: workspace.updatedAt,
		lastSearchedAt: workspace.lastSearchedAt,
	};
};

const parseGetFromServer = (response: GetWorkspacesResponse): ClientWorkspace[] => {
	return [
		workspaceUnassignedNodesTransformer(response.unassigned.count),
		workspaceTrashedNodesTransformer(response.trash.count),
		...response.all.map(parseWorkspaceFromServer),
	];
};
